import React from 'react'
import { CloseSVG } from '../../../assets/CloseSVG'
import { backRemu } from '../../../urlApi';
import axios from 'axios';
import { useSolicitudes } from '../../../hooks/useSolicitudes';
import Swal from 'sweetalert2';

export const DeleteSolicitudButton = ({id,setSolicitudes, solicitudes}) => {

  const deleteSolicitud = async() => {

     await axios.get(`${backRemu}vacaciones/eliminar-solicitud/${localStorage.getItem('conid')}/${id}`);
     setSolicitudes(solicitudes.filter((solicitud) => solicitud.id !== id));

  }

  const openAlert = () => {

    Swal.fire({
      title: "¿Quieres eliminar esta solicitud?",
      showCancelButton: true,
      confirmButtonText: "Eliminar",
      cancelButtonText:'Cancelar'
    }).then((result) => {
      /* Read more about isConfirmed, isDenied below */
      if (result.isConfirmed) {
        deleteSolicitud()
      } else if (result.isDenied) {
        // Swal.fire("Changes are not saved", "", "info");
      }
    });

  }

  return (
    <p onClick={openAlert} style={{cursor:'pointer'}} ><CloseSVG/></p> 
  )
}
